import React from "react";

const TransactionIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16,16.2c1.3807,0 2.5,-1.119 2.5,-2.5c0,-1.381 -1.1193,-2.5 -2.5,-2.5c-1.3807,0 -2.5,1.119 -2.5,2.5c0,1.381 1.1193,2.5 2.5,2.5z"
        fill="#1A8B5A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.1608 10.07L25.3637 12.3841C26.8525 13.9906 27.1565 15.1801 27.1565 16.1687C27.1565 17.8234 26.299 19.2694 25.0061 20.1005L24.3572 19.0911C25.3223 18.4707 25.9565 17.3968 25.9565 16.1687C25.9565 15.5248 25.7972 14.6184 24.4862 13.2027L22.2916 10.8974L23.1608 10.07Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7255 9.70173L23.091 9.88945C23.3699 10.0327 23.7604 10.1331 24.3654 10.2112L27.0775 10.564L26.9226 11.754L24.2118 11.4013C23.9172 11.3633 23.6407 11.3173 23.383 11.2557C23.4089 11.5205 23.4169 11.8008 23.4169 12.0964V14.828H22.2169V12.0964C22.2169 11.4716 22.1746 11.0765 22.0708 10.7872L21.9338 10.4055L22.7255 9.70173Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.417 16.6286V18.453C23.417 19.7397 22.3744 20.7968 21.0732 20.7968H9.92703V19.5968H21.0732C21.7072 19.5968 22.217 19.0815 22.217 18.453V16.6286H23.417Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.91683 10.0455C9.28837 10.0455 8.77303 10.5552 8.77303 11.1893V15.6445H7.57303V11.1893C7.57303 9.88797 8.63015 8.84546 9.91683 8.84546H21.063C21.4051 8.84546 21.873 8.91993 22.314 9.1995C22.7697 9.48832 23.1496 9.96701 23.3369 10.685L22.1758 10.9879C22.0607 10.5468 21.856 10.3299 21.6716 10.213C21.4726 10.0869 21.245 10.0455 21.063 10.0455H9.91683Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.8335 16.427C3.8335 14.7723 4.69103 13.3263 5.98388 12.4952L6.63279 13.5046C5.66777 14.125 5.0335 15.1989 5.0335 16.427C5.0335 17.0709 5.19284 17.9773 6.5038 19.393L8.69838 21.6983L7.82924 22.5257L5.62629 20.2116C4.13756 18.6051 3.8335 17.4156 3.8335 16.427Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.78313 17.7776V20.5092C8.78313 21.1341 8.82542 21.5292 8.92928 21.8185L9.06631 22.2002L8.27461 22.9039L7.90905 22.7162C7.63015 22.573 7.23968 22.4726 6.6347 22.3945L3.92261 22.0416L4.07744 20.8517L6.78827 21.2044C7.08279 21.2424 7.35939 21.2884 7.61705 21.35C7.59118 21.0852 7.58313 20.8048 7.58313 20.5092V17.7776H8.78313Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2169 21.4063V16.9511H23.4169V21.4063C23.4169 22.7076 22.3598 23.7501 21.0731 23.7501H9.92695C9.58481 23.7501 9.11692 23.6757 8.67587 23.3961C8.22022 23.1073 7.84028 22.6286 7.65297 21.9106L8.81412 21.6077C8.9292 22.0488 9.13389 22.2657 9.31831 22.3826C9.51732 22.5087 9.74494 22.5501 9.92695 22.5501H21.0731C21.7015 22.5501 22.2169 22.0404 22.2169 21.4063Z"
      />
    </svg>
  );
};

export default TransactionIcon;
